import React from "react";

import ProductGroupItem from "./ProductGroupItem";
/**
 * @typedef {import('./ProductGroupItem').ProductGroup} ProductGroup
 */
/**
 * 
 * @param {Object} props
 * @param {[ProductGroup]} props.groups
 * @param {number}props.selectedGroupId
 * @param {(e:Event)=>void} props.onGroupSelect
 * @param {boolean} props.isLoading
 * @returns 
 */
const ProductGroupList = ({
    groups = [],
    selectedGroupId,
    onGroupSelect,
    isLoading = false
}) => {

    if (!isLoading && !groups.length) {
        return (
            <div className="product-group-list">
                <div className="product-group-empty">
                    گروهی وجود ندارد
                </div>
            </div>
        );
    }
    if (isLoading) {
        return (
            <div className="product-group-list">
                <div className="product-group-empty">
                    در حال دریافت اطلاعات...
                </div>
            </div>
        )
    }

    return (
        <div className="product-group-list">

            {groups.map(group => (
                <ProductGroupItem
                    key={
                        group.GroupID 
                    }
                    group={group}
                    selected={
                        String(
                            group.GroupID
                        ) === String(selectedGroupId)
                    }
                    onClick={onGroupSelect}
                />
            ))}

        </div>
    );
};

export default ProductGroupList;

